import matchedFormsPattern from "./matchedFormsPattern";

// The term's own forms and the wider entries that hide them, in one pattern. The wider alternative
// comes first so it wins at a shared starting word and consumes the span, exactly as the server's
// matcher does — a `term` group therefore marks an occurrence the count actually includes.
const termPattern = (forms: string[], widerForms: string[] = []): string => {
  const term = `(?<term>${matchedFormsPattern(forms)})`;
  return widerForms.length === 0 ? term : `(?<wider>${matchedFormsPattern(widerForms)})|${term}`;
};

export default termPattern;
